import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import capitalize from '../../../utils/capitalize';
import { ButtonsPrimary, ButtonsSecondary, ButtonsTertiary } from '../../ComponentApp/buttoms';
import TruncatedText from '../../UI/TruncatedText';
import { IconInfo } from '../../XcalaComponents';
import { BtnGroup } from '../../portfolio/detailsPortfolio/distributionFunds/BtnGroup';
import ChartnvestmentContainerProductsDetail from './ChartnvestmentContainerProductsDetail';
import {
  BodyComponent,
  BtnContainer,
  BtnGroupContainer,
  BtnGroupFunds,
  BtnGroupWrapper,
  ButtonsWrapperStack,
  CardExpectedReturn,
  CardsContentDocumentacion,
  ChartSection,
  ConditionsSection,
  ContainerProductsDetails,
  HeaderComponent,
  ProductDetailContent,
  RiskWarningBox,
  RiskWarningTypography,
  TitleCardsDocumentation,
  TitleDescription,
  TopSectionProducts,
  TypographyTitleExpected,
  TypographyValueExpected,
} from './ProductsStyledComponents';
import SectionGeneralConditionDetail from './SectionGeneralConditionDetail';

const BodyDetailProduct = ({
  doGetSecurityDividends,
  securitySelected,
  description,
  conditions,
  active,
  fileAs,
  idSelected,
  onChangeMonths,
  loadingGetPriceRange,
  currency,
  custom,
  chartData,
  dividends,
  showLabels,
  successGetPriceRange,
  setCurrency,
  simulation = ' Rescatar Inversión',
  investmentMore = ' Invertir Más',
  ModelId,
  visible,
  statusDividendFinfolio,
  updateChartData,
  documents,
  showRiskWarning,
  handleInvestment,
  handleSimulation,
  handleRescueInvestment,
  handleInvestMore,
  handleClose,
  handleOpen,
  successGetExchangeRateHistory,
  loadingGetExchangeRateHistory,
  loadingGetExchangeRate,
  errorGetPriceRange,
}) => {
  const theme = useTheme();
  const user = useSelector(state => state.auth.user);
  return (
    <ContainerProductsDetails>
      <TopSectionProducts>
        <CardExpectedReturn>
          <Stack>
            <TypographyTitleExpected>Rentabilidad esperada</TypographyTitleExpected>
          </Stack>
          <Stack
            direction='row'
            spacing={1}
            alignItems='center'
            sx={{
              marginRight: {
                xs: '0px',
                sm: '20px',
              },
            }}>
            <TypographyValueExpected>{fileAs.profit} %</TypographyValueExpected>
            <IconInfo src='/assets/images/perfiles/info.svg' />
          </Stack>
        </CardExpectedReturn>

        <BtnGroupContainer
          direction='column'
          sx={{ marginTop: { xs: '32px', md: '0px', lg: '0px' }, width: '40%' }}>
          <ButtonsWrapperStack>
            <BtnGroupFunds>
              <BtnContainer flexDirection={{ md: 'row', xs: 'column' }} gap={2}>
                <ButtonsSecondary
                  name={simulation}
                  onClick={() => handleRescueInvestment(idSelected)}
                  fullWidth
                />
                <ButtonsPrimary
                  name={investmentMore}
                  onClick={() => handleInvestMore(ModelId)}
                  fullWidth
                />
              </BtnContainer>
              {statusDividendFinfolio && (
                <Stack width={'100%'} marginTop={1}>
                  {fileAs.products === true &&
                    (!visible && statusDividendFinfolio.length > 0 ? (
                      <ButtonsTertiary
                        name='Reinvertir Dividendos'
                        endIcon={<KeyboardArrowRightIcon />}
                        fullWidth
                        onClick={handleOpen}
                        imgUrl='/assets/images/edit.svg'
                        sx={{ whiteSpace: 'nowrap', marginLeft: '2px' }}
                      />
                    ) : statusDividendFinfolio.length > 0 ? (
                      <ButtonsTertiary
                        name='Cancelar'
                        startIcon={<CloseIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        fullWidth
                        onClick={handleClose}
                      />
                    ) : null)}
                </Stack>
              )}
            </BtnGroupFunds>
          </ButtonsWrapperStack>
        </BtnGroupContainer>
      </TopSectionProducts>

      <Stack marginTop={{ sm: '32px', xs: '32px' }}>
        <TitleDescription>Descripción</TitleDescription>
        <TruncatedText seeMore='[+]' seeLess='[-]' text={description} limit={100} />
      </Stack>

      <ProductDetailContent>
        <ChartSection>
          <ChartnvestmentContainerProductsDetail
            onChangeMonths={onChangeMonths}
            active={active}
            loadingGetPriceRange={loadingGetPriceRange}
            currency={currency}
            custom={custom}
            chartData={chartData}
            dividends={dividends}
            showLabels={showLabels}
            successGetPriceRange={successGetPriceRange}
            setCurrency={setCurrency}
            updateChartData={updateChartData}
            successGetExchangeRateHistory={successGetExchangeRateHistory}
            loadingGetExchangeRateHistory={loadingGetExchangeRateHistory}
            doGetSecurityDividends={doGetSecurityDividends}
            securitySelected={securitySelected}
            loadingGetExchangeRate={loadingGetExchangeRate}
            errorGetPriceRange={errorGetPriceRange}
          />
        </ChartSection>
        <ConditionsSection>
          <SectionGeneralConditionDetail conditions={conditions} />
        </ConditionsSection>
      </ProductDetailContent>
      <BtnGroupWrapper>
        <BtnGroup
          goToSimulator={() => handleSimulation()}
          goToInvestment={() => handleInvestment()}
        />
      </BtnGroupWrapper>

      {showRiskWarning && (
        <RiskWarningBox>
          <img src='/assets/images/warning.svg' alt='risk' style={{ display: 'inline' }} />
          <RiskWarningTypography>
            Este fondo supera el riesgo definido en tu perfil {capitalize(user['custom:profile'])}
          </RiskWarningTypography>
        </RiskWarningBox>
      )}

      <Stack
        width={'100%'}
        borderRadius={2}
        flexDirection={'row'}
        gap={2}
        flexWrap={'wrap'}
        justifyContent={'flex-start'}
        alignItems={'center'}
        sx={{
          backgroundColor: theme.palette.white.main,
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          borderTop: '1px solid rgba(170, 167, 167, 0.25)',
        }}>
        <CardsContentDocumentacion>
          <HeaderComponent flexDirection={'column'} gap={0} p={2}>
            <TitleCardsDocumentation>Documentación de interés</TitleCardsDocumentation>
          </HeaderComponent>

          <BodyComponent>
            {documents.map((document, index) => {
              return (
                <Stack
                  key={document.id || index}
                  direction={'row'}
                  sx={{
                    alignItems: 'center',
                    width: { xs: '100%', md: '20%' },
                    padding: { xs: '5px' },
                  }}
                  onClick={() => window.open(document.value, '_blank')}>
                  <Stack sx={{ height: '25px', width: '25px', cursor: 'pointer' }}>
                    <img src='/assets/images/pdf.svg' alt='' width={'100%'} height={'100%'} />
                  </Stack>
                  <Typography
                    component={'span'}
                    sx={{
                      marginLeft: '10px',
                      color: theme.palette.primary.dark,
                      cursor: 'pointer',
                    }}>
                    {document.data}
                  </Typography>
                </Stack>
              );
            })}
          </BodyComponent>
        </CardsContentDocumentacion>
      </Stack>
    </ContainerProductsDetails>
  );
};

export default BodyDetailProduct;
